var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img"},[_c('j-image-upload',{attrs:{"disabled":_vm.disabled},on:{"change":_vm.commonComponent},model:{value:(_vm.fcz.commonDataInfo),callback:function ($$v) {_vm.$set(_vm.fcz, "commonDataInfo", $$v)},expression:"fcz.commonDataInfo"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }